import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  darkMode: false,
  isMobile: false,
  mobileBreakPoint: 1024,
  expanded: true
};

export default {
  state,
  actions,
  getters,
  mutations
};
